import script from "./HrMarkupTable.vue?vue&type=script&setup=true&lang=js"
export * from "./HrMarkupTable.vue?vue&type=script&setup=true&lang=js"

import "./HrMarkupTable.vue?vue&type=style&index=0&id=6bbe808d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bbe808d"]])

export default __exports__
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QMarkupTable});
